import Jumbotron from './Jumbotron';
import ChurchNavbar from './ChurchNavbar';

const Header = () => {
    return (
    <>
        <Jumbotron />
        <ChurchNavbar />
    </>
    )
};

export default Header;